import * as React from 'react'

import { type TagColor as Color, Tag } from '@factorialco/deprecated-design-system'

interface Props {
  text: string
  type: Color
}

const StatusTag = ({ text, type }: Props) => {
  return (
    <Tag leftItem="circle" showCircle type={type}>
      {text}
    </Tag>
  )
}

export default StatusTag
